var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sha512 } from "./crypto";
function verifyCoachServerResponse(csResponse) {
    if ("error" in csResponse) {
        throw new Error(`${csResponse.error}-${csResponse.error_description}`);
    }
    const { access_token, accessCode, expires_in } = csResponse;
    if (!accessCode || !access_token || !expires_in) {
        throw new Error("Malformed login response");
    }
    return csResponse;
}
function formatCoachServerResponse(csResponse) {
    const { access_token, accessCode, expires_in, refresh_token } = csResponse;
    return {
        accessCode,
        accessToken: access_token,
        refreshToken: refresh_token,
        expiresIn: expires_in,
    };
}
/** Fetch user profile to fill in the missing user information */
export function fetchUserProfile(csServerUrl, csAuthToken, userAccessCode) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield fetch(`${csServerUrl}/users/${userAccessCode}/profile`, {
            method: "GET",
            headers: {
                Authorization: `bearer ${csAuthToken}`,
            },
        });
        return (yield result.json());
    });
}
export function loginViaCoachServerWithToken(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const body = new URLSearchParams({
            client_id: params.csClientId,
            grant_type: "password",
            request: JSON.stringify({
                mode: "LOGIN",
                type: "ONE_LOGIN",
                email: params.email,
                principal: params.email,
                credentials: params.accessToken,
                extras: Object.assign({ packageName: `com.noom.web.coachdashboard` }, params.csExtras),
            }),
        });
        const result = yield fetch(`${params.csServerUrl}/oauth/token?app=${params.csClientId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body,
        });
        const data = verifyCoachServerResponse((yield result.json()));
        return formatCoachServerResponse(data);
    });
}
export function loginViaCoachServerWithPassword(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const body = new URLSearchParams({
            client_id: "noom-coach",
            grant_type: "password",
            request: JSON.stringify({
                mode: "LOGIN",
                type: "EMAIL_AND_PASSWORD",
                email: params.email,
                principal: params.email,
                credentials: yield sha512(params.password),
                extras: Object.assign({ packageName: "com.noom.web.userportal", reCaptchaV3ResponseToken: params.reCaptchaToken }, params.csExtras),
            }),
        });
        const result = yield fetch(`${params.csServerUrl}/oauth/token?app=${params.csClientId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body,
        });
        const data = verifyCoachServerResponse((yield result.json()));
        return formatCoachServerResponse(data);
    });
}
//# sourceMappingURL=coachServer.js.map